import {
  Storefront,
  Globe,
  Robot,
  Briefcase,
  PaintBrush,
  Megaphone,
  Devices,
  Buildings,
  FirstAid,
  GraduationCap,
  Hamburger,
  Airplane,
  ShoppingBag,
  Tag,
  Wrench,
  Code,
} from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";

const CATEGORY_ICON_MAP: Record<string, Icon> = {
  ecommerce: Storefront,
  "e-commerce": Storefront,
  web: Globe,
  ai: Robot,
  consulting: Briefcase,
  design: PaintBrush,
  marketing: Megaphone,
  technology: Devices,
  "real estate": Buildings,
  healthcare: FirstAid,
  education: GraduationCap,
  "food & beverage": Hamburger,
  travel: Airplane,
  retail: ShoppingBag,
  tools: Wrench,
  "web development": Code,
};

const DEFAULT_ICON: Icon = Tag;

export function getCategoryIcon(category: string | null | undefined): Icon {
  if (!category) return DEFAULT_ICON;
  return CATEGORY_ICON_MAP[category.toLowerCase()] || DEFAULT_ICON;
}
